import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  lazy,
  Suspense,
  useContext
} from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useHistory,
  Link,
} from 'react-router-dom';
import { FormattedHTMLMessage, FormattedMessage, injectIntl, useIntl } from 'react-intl'
import {
  LANG_JP,
  language,
  showQuiz,
  showPromo,
  pageDefaultTitle,
  LANG_RU,
  LANG_ARABIA,
  LANG_ARABIA_EN,
} from 'Root/constants';
import { LANG_AZ } from '../../constants';
import './define.scss';
import {
  sprite_bean_blue,
  sprite_ring_text_classic,
  sprite_ring_text_fresh,
  icon_specs_power,
  icon_specs_curve,
  icon_specs_thickness,
  icon_specs_material,
  icon_specs_wetting,
  icon_specs_water,
  icon_specs_o2,
  icon_specs_package,
  img_specs_classic,
  sprite_ring_text_specs,
  img_wear_classic,
  img_wear_insert_01,
  img_wear_insert_02,
  img_wear_insert_03,
  img_wear_insert_04,
  img_wear_remove_01,
  img_wear_remove_02,
  img_wear_remove_03,
  img_wear_remove_04,
  img_package_fresh,
  img_package_classic,
} from '../../assets/imgs';
import ShowNow from '../showNow';
import References from '../references';
import VirtualMirror from '../virtualMirror/VirtualMirror';
import { ContextContainer } from '../virtualMirror/context';
import content from 'Content/content.json';
import { imageSet } from '../helper/Images';
import { Image } from '../commonComponents';
import AppContext from '../context';
import { Helmet } from 'react-helmet';

const Define = (props) => {
  const [tabControls, setTabControls] = useState('insertion');
  const [selectedLens, setLens] = useState(null);
  const [selectedLensName, setLensName] = useState(null);
  const [showDefineModal, setShowDefineModal] = useState(false);
  const [defineType, setDefineType] = useState('');
  const location = useLocation();
  const lensType = Object.keys(content.data.productInfo[language]);
  const appContext = useContext(AppContext);

  const {
    data: {
      productInfo: {
        [language]: { [lensType[0]]: lensList },
        [language]: { [lensType[1]]: defineList }
      },
    },
  } = content;

  const getDefineType = (pathname) => {
    const pattern = /\/define-(\w+)/;
    const match = pathname.match(pattern);
    if(window.sessionStorage.getItem('productInfo')) {
      const productInfo = JSON.parse(window.sessionStorage.getItem('productInfo'));
      const typeName = productInfo.type == 'freshLens' ? 'fresh' : 'classic';
      if(typeName == match[1]) {
        setLens(productInfo.data);
        setLensName(productInfo.data.name);
      }
      else {
        typeName == 'classic' ? setLens(defineList[0]) : setLens(lensList[0]);
        setLensName(null);
      }
    }
    else {
      match[1] == 'classic' ? setLens(lensList[0]) : setLens(defineList[0]);
      setLensName(lensList[0].name);
    }

    setDefineType(match[1]);
    
  };

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  useEffect(() => {
    getDefineType(location.pathname);
    
  }, [location.pathname]);

  useEffect(() => {
    if (defineType == 'fresh') {
      document.documentElement.style.setProperty(
        '--clr-accent',
        selectedLens.colors.accent
      );
      document.documentElement.style.setProperty(
        '--clr-bg',
        selectedLens.colors.bg
      );
    } else if (defineType == 'classic') {
      document.documentElement.style.setProperty('--clr-accent', 'white');
      document.documentElement.style.setProperty(
        '--clr-bg',
        selectedLens.colors.bg
      );
    }
  }, [selectedLens]);

  const history = useHistory();

  const redirectTo = (url) => {
    history.push(url);
    

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  const sectionRef = useRef(null);

  const choosePro = (data, index, type) => {
    setLens(data);
    setLensName(data.name);
    console.log(type);
    window.sessionStorage.setItem('productInfo', JSON.stringify({
      'data': data,
      'type': type === 'classic' ? 'classicLens': 'freshLens',
      'index': index
    }));
  }

  const scrollToSection = () => {
    sectionRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (showDefineModal) {
      document.body.style.overflow = 'hidden';
    } else {
      if (window.YMK) {
        YMK.closeEngine();
      }
      document.body.style.overflow = 'auto';
      getDefineType(location.pathname);

    }

    // 清除 effect 时恢复原始 overflow 属性
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showDefineModal]);

  const intl = useIntl();
  const titles = {
    classic: intl.formatMessage({ id: 'meta.title.classic', defaultMessage: '1-DAY ACUVUE® DEFINE®' }),
    fresh: intl.formatMessage({ id: 'meta.title.fresh', defaultMessage: '1-DAY ACUVUE® DEFINE® CLASSIC coloured contact lens crafted with natural-toned hues that enhance and accentuate your eyes.' })
  };
  const descriptions = {
    classic: intl.formatMessage({ id: 'meta.desc.classic', defaultMessage: '1-DAY ACUVUE® DEFINE®' }),
    fresh: intl.formatMessage({ id: 'meta.desc.fresh', defaultMessage: '1-DAY ACUVUE® DEFINE® FRESH coloured contact lens with nature-inspired brightening colours to craft your own beautiful.' })
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>{titles[defineType]}</title>
        <meta name="description" content={descriptions[defineType]} />
        <meta property="og:title" content={titles[defineType]} />
        <meta property="og:description" content={descriptions[defineType]} />
      </Helmet>
      <main>
        {/* Summary */}
        {defineType == 'classic' && (
          <section className="summary-wrapper">
            <div className="button-bar">
              <Link to="/define-fresh" className="btn block">
                <FormattedMessage id="buttonText.discoverDefineFresh" defaultMessage="Discover Define® Fresh" />
                <div className="arrow btn-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 12"
                    fill="none"
                  >
                    <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3" />
                  </svg>
                </div>
              </Link>
              <Link to="/define-fresh" className="btn tertiary">
                <FormattedMessage id="buttonText.discoverDefineFresh" defaultMessage="Discover Define® Fresh" />
                <div className="arrow btn-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 12"
                    fill="none"
                  >
                    <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3" />
                  </svg>
                </div>
              </Link>
            </div>
            <div className="heading">
              <h5><FormattedMessage id="headline.classic.title" defaultMessage="Define® Classic" /></h5>
              <h3><FormattedHTMLMessage id="headline.classic.description" defaultMessage="Innovatively crafted <em>natural-toned hues </em>featuring limbal rings that <em>accentuate with bold&nbsp;charisma</em>" /></h3>
            </div>
            <img src={sprite_bean_blue} className="bean" />
            <div className="decoration">
              <img src={sprite_ring_text_classic} />
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16">
                <path d="M6 15C6 12.2387 8.23835 10 11 10" />
                <path d="M6 15C6 12.2387 3.76165 10 1 10" />
                <path d="M6 1L6 15" />
              </svg>
            </div>
          </section>
        )}
        {defineType == 'fresh' && (
          <section className="summary-wrapper">
            <div className="button-bar">
              <Link to="/define-classic" className="btn block">
                <FormattedMessage id="buttonText.discoverDefineClassic" defaultMessage="Discover Define® Classic" />
                <div className="arrow btn-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 12"
                    fill="none"
                  >
                    <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3" />
                  </svg>
                </div>
              </Link>
              <Link to="/define-classic" className="btn tertiary">
                <FormattedMessage id="buttonText.discoverDefineClassic" defaultMessage="Discover Define® Classic" />
                <div className="arrow btn-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 12"
                    fill="none"
                  >
                    <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3" />
                  </svg>
                </div>
              </Link>
            </div>
            <div className="heading">
              <h5><FormattedMessage id="headline.fresh.title" defaultMessage="Define® Fresh" /></h5>
              <h3><FormattedHTMLMessage id="headline.fresh.description" defaultMessage="Scientifically designed to <em>enhance, brighten </em>and <em>lighten </em>with <em>playful nature-inspired colours</em>" /></h3>
            </div>
            <img src={sprite_bean_blue} className="bean" />
            <div className="decoration">
              <img src={sprite_ring_text_fresh} />
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16">
                <path d="M6 15C6 12.2387 8.23835 10 11 10" />
                <path d="M6 15C6 12.2387 3.76165 10 1 10" />
                <path d="M6 1L6 15" />
              </svg>
            </div>
          </section>
        )}
        {/* Product Selector */}
        {defineType && (
          <section data-filter={defineType} className="product-selector">
            <div className="product-selector-wrapper">
              <div className="on-eye-image">
                <img
                  src={require(`../../assets/imgs/define/on-eye_${defineType}-${selectedLens.imageFileName}.jpg`)}
                />
              </div>
              <div className="lens-tray">
                <div className="collection classic">
                  {defineType === 'fresh' ? defineList.map((data, index) => (
                      <figure
                        onClick={() => choosePro(data, index, defineType)}
                        key={data.key}
                        className={
                          selectedLensName == data.name ? 'active' : ''
                        }
                      >
                        <div className="selection-ring"></div>
                        <Image
                          src={imageSet[data.icon]}
                          alt="Recommendation"
                        />
                      </figure>
                    )) : 
                    lensList.map((data, index) => (
                      <figure
                        key={data.name}
                        onClick={() => choosePro(data, index, defineType)}
                        className={
                          selectedLensName == data.name ? 'active' : ''
                        }
                      >
                        <div className="selection-ring"></div>
                        <Image
                          src={imageSet[data.icon]}
                          alt="Recommendation"
                        />
                      </figure>
                    ))}
                </div>
              </div>
              <div className="description">
                <h5><FormattedHTMLMessage id={"headline." + selectedLens.title_name + ".title"} defaultMessage={selectedLens.title_name} /></h5>
                <h2>
                  <em>{selectedLens.name[language]}</em>
                  <em><FormattedHTMLMessage id={"product." + selectedLens.key + ".name"} defaultMessage={selectedLens.name} /></em>
                </h2>
                <p
                  style={{
                    color:
                      defineType == 'classic' ? 'var(--cloud)' : 'var(--chasm)',
                  }}
                >
                  <FormattedHTMLMessage id={"product." + selectedLens.key + ".description"} defaultMessage={selectedLens.description} />
                </p>
              </div>
              <div className="button-stack">
                <div
                  className="btn primary dynamic"
                  id="try-vm"
                  onClick={() => setShowDefineModal(true)}
                >
                  <div className="mirror btn-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 21 27"
                      stroke="none"
                    >
                      <path d="M8.98644 14.0913C8.721 14.0873 8.53883 13.9062 8.51454 13.6117C8.46943 13.0604 8.31445 12.5577 7.94086 12.1336C7.53604 11.6737 7.03176 11.4139 6.42454 11.3491C6.3268 11.3387 6.22733 11.3329 6.13133 11.3121C5.88902 11.2595 5.75254 11.1073 5.76006 10.8562C5.76758 10.6063 5.91273 10.4773 6.15505 10.4177C6.56044 10.3188 6.99243 10.2598 7.35619 10.0723C8.00679 9.73678 8.3717 9.15594 8.47406 8.42295C8.49257 8.28931 8.49835 8.15336 8.52726 8.02204C8.57469 7.80625 8.71001 7.67261 8.93671 7.65872C9.17266 7.64426 9.33285 7.75534 9.40224 7.9827C9.42538 8.05906 9.43463 8.14121 9.43926 8.22105C9.50576 9.40181 10.4507 10.3205 11.5576 10.3899C12.0012 10.4177 12.1868 10.5808 12.1874 10.8678C12.1885 11.1628 11.9867 11.3104 11.5322 11.348C10.3987 11.4411 9.5526 12.3158 9.44215 13.5157C9.42017 13.7517 9.37564 13.9635 9.12234 14.0566C9.07261 14.0751 9.01883 14.0832 8.98702 14.0913H8.98644ZM9.81342 10.8603C9.56417 10.619 9.20678 10.2731 8.96793 10.0417C8.73603 10.2708 8.37748 10.6254 8.13748 10.8626C8.38153 11.1119 8.73198 11.4712 8.96215 11.7061C9.21025 11.4596 9.55781 11.1148 9.81342 10.8603Z"></path>
                      <path d="M15.5762 4.69074C14.7677 5.36472 14.0084 5.99704 13.2497 6.62937C13.16 6.704 13.0727 6.78268 12.9779 6.85094C12.7477 7.01698 12.4817 6.99905 12.3215 6.81276C12.1491 6.61143 12.1781 6.35052 12.3978 6.14052C12.4429 6.09713 12.4944 6.0601 12.543 6.0196C13.2745 5.40926 14.0061 4.79892 14.7648 4.16602"></path>
                      <path d="M16.8362 6.1748C16.178 6.72324 15.5373 7.25779 14.8954 7.79119C14.7016 7.95202 14.5137 8.12095 14.3078 8.265C14.0956 8.41368 13.8579 8.37261 13.7023 8.18863C13.5514 8.01045 13.5606 7.76747 13.7306 7.57598C13.7781 7.52275 13.8353 7.47763 13.8903 7.43135C14.4217 6.98762 15.6784 6.00818 16.2104 5.56445"></path>
                      <path d="M20.8001 10.0873C20.8001 5.0021 16.6646 0.864502 11.5807 0.864502C6.49681 0.864502 2.36133 5.0021 2.36133 10.0873C2.36133 14.3319 5.24246 17.9153 9.15124 18.9844C9.15645 19.0232 9.15645 19.0683 9.15124 19.1221C9.00551 20.6078 8.87423 22.0952 8.73891 23.582C8.651 24.5498 8.95635 25.3679 9.73996 25.9522C10.6132 26.6036 11.5715 26.6811 12.5257 26.1483C13.4914 25.6097 13.9113 24.7384 13.8321 23.6456C13.7546 22.5782 13.6389 21.5137 13.5418 20.4481C13.5013 20.0073 13.4637 19.5658 13.4255 19.1244C17.6287 18.2676 20.8007 14.5408 20.8007 10.0873H20.8001ZM11.8832 25.4483C11.2089 25.7144 10.449 25.5073 9.99383 24.9305C9.73244 24.599 9.60984 24.2149 9.64627 23.7977C9.78217 22.2317 9.93022 20.6668 10.0748 19.1019C10.0765 19.0857 10.0904 19.0712 10.0898 19.0718H12.4869C12.5378 19.6011 12.5939 20.1617 12.646 20.7223C12.7362 21.6971 12.8223 22.6725 12.9131 23.6473C12.99 24.4769 12.598 25.1665 11.8832 25.4483ZM11.5807 18.3845C7.00745 18.3845 3.28662 14.6623 3.28662 10.0873C3.28662 5.51236 7.00745 1.79014 11.5807 1.79014C16.154 1.79014 19.8748 5.51236 19.8748 10.0873C19.8748 14.6623 16.154 18.3845 11.5807 18.3845Z"></path>
                      <path d="M11.5808 17.4217C7.53786 17.4217 4.24902 14.1311 4.24902 10.0872C4.24902 6.04333 7.53844 2.75269 11.5808 2.75269C15.6232 2.75269 18.9126 6.04333 18.9126 10.0872C18.9126 14.1311 15.6232 17.4217 11.5808 17.4217ZM11.5808 3.67774C8.04793 3.67774 5.17432 6.55301 5.17432 10.0866C5.17432 13.6202 8.04851 16.4955 11.5808 16.4955C15.1131 16.4955 17.9873 13.6202 17.9873 10.0866C17.9873 6.55301 15.1131 3.67774 11.5808 3.67774Z"></path>
                      <path d="M4.55361 2.63014C4.4524 2.39873 4.24884 2.35245 4.0233 2.33104C3.34668 2.26798 2.83199 1.77103 2.76953 1.09937C2.76606 1.06119 2.76143 1.02705 2.75623 0.995233C2.72384 0.682831 2.59372 0.531258 2.35373 0.503488C2.07672 0.47167 1.88125 0.631921 1.84019 0.943745C1.83094 0.979613 1.82457 1.01895 1.82168 1.06466C1.79682 1.46904 1.62737 1.83062 1.28096 2.04178C1.03808 2.18988 0.743138 2.26567 0.461503 2.33336C0.17177 2.40394 -0.00172203 2.55204 1.28903e-05 2.80601C0.00174781 3.05593 0.159048 3.21561 0.44184 3.25842C0.574851 3.27867 0.712488 3.28676 0.838559 3.32842C1.45099 3.52974 1.76732 3.96711 1.83325 4.60117C1.86563 4.91357 1.99575 5.06572 2.23575 5.09292C2.52606 5.12589 2.72673 4.94944 2.75449 4.60811C2.78688 4.20315 2.93897 3.86471 3.24721 3.59627C3.51092 3.3666 3.82783 3.29371 4.16325 3.25321C4.49231 3.21387 4.67563 2.91015 4.55303 2.63072L4.55361 2.63014ZM2.2959 3.18494L1.9038 2.79271L2.2959 2.40047L2.68799 2.79271L2.2959 3.18494Z"></path>
                    </svg>
                  </div>
                  <FormattedMessage id="buttonText.tryTheVirtualMirror" defaultMessage="Try the Virtual Mirror" />
                </div>
                <Link
                  to="#shopNow"
                  className="btn tertiary dynamic"
                  onClick={scrollToSection}
                >
                  <FormattedMessage id="buttonText.shopNow" defaultMessage="Shop Now" />
                  <div className="shopping-cart">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 18">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.2221 8.9775C13.9671 9.4425 13.4721 9.75 12.9096 9.75H7.32207L6.49707 11.25H15.4971V12.75H6.49707C5.35707 12.75 4.63707 11.5275 5.18457 10.5225L6.19707 8.6925L3.49707 3H1.99707V1.5H4.44957L5.15457 3H16.2546C16.8246 3 17.1846 3.615 16.9071 4.11L14.2221 8.9775ZM14.9796 4.5H5.86707L7.64457 8.25H12.9096L14.9796 4.5ZM6.49707 13.5C5.67207 13.5 5.00457 14.175 5.00457 15C5.00457 15.825 5.67207 16.5 6.49707 16.5C7.32207 16.5 7.99707 15.825 7.99707 15C7.99707 14.175 7.32207 13.5 6.49707 13.5ZM12.5046 15C12.5046 14.175 13.1721 13.5 13.9971 13.5C14.8221 13.5 15.4971 14.175 15.4971 15C15.4971 15.825 14.8221 16.5 13.9971 16.5C13.1721 16.5 12.5046 15.825 12.5046 15Z"
                      ></path>
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </section>
        )}
        {/* Features */}
        <section className="features-wrapper">
          <ul className="feature-list">
            <li className="feature-item">
              <div className="feature-item-wrapper">
                <svg viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path d="m35 1c18.8 0 34 15.2 34 34 0 18.8-15.2 34-34 34-18.8 0-34-15.2-34-34 0-18.8 15.2-34 34-34z" />
                    <g clipPath="url(#a)" strokeMiterlimit="10">
                      <path d="m35.5 33.8c5.9 0 10.8-4.8 10.8-10.6s-4.8-10.6-10.8-10.6-10.8 4.8-10.8 10.6 4.9 10.6 10.8 10.6z" />
                      <path d="m35.5 56.5c5.9 0 10.8-4.8 10.8-10.6 0-5.9-4.8-10.6-10.8-10.6s-10.8 4.7-10.8 10.6 4.9 10.6 10.8 10.6z" />
                      <path d="m24.7 45.9c5.9 0 10.8-4.8 10.8-10.6 0-5.9-4.8-10.6-10.8-10.6s-10.7 4.7-10.7 10.5c0 5.9 4.8 10.7 10.7 10.7z" />
                      <path d="m46.3 45.9c5.9 0 10.8-4.8 10.8-10.6 0-5.9-4.8-10.6-10.8-10.6s-10.8 4.8-10.8 10.6 4.8 10.6 10.8 10.6z" />
                      <path d="m27.9 53.4c5.9 0 10.8-4.8 10.8-10.6s-4.8-10.6-10.8-10.6-10.8 4.8-10.8 10.6 4.9 10.6 10.8 10.6z" />
                      <path d="m43.1 38.4c5.9 0 10.8-4.8 10.8-10.6s-4.9-10.7-10.8-10.7-10.8 4.8-10.8 10.6 4.9 10.7 10.8 10.7z" />
                      <path d="m27.9 38.4c5.9 0 10.8-4.8 10.8-10.6s-4.8-10.6-10.8-10.6-10.8 4.8-10.8 10.6 4.9 10.6 10.8 10.6z" />
                      <path d="m43.1 53.4c5.9 0 10.8-4.8 10.8-10.6s-4.9-10.7-10.8-10.7-10.8 4.8-10.8 10.6 4.9 10.7 10.8 10.7z" />
                    </g>
                  </g>
                </svg>
                <div className="separator"></div>
                <div className="details">
                  <h6><FormattedHTMLMessage id="features.paragraph1.title" defaultMessage="Design with a purpose" /></h6>
                  <p><FormattedHTMLMessage id="features.paragraph1.description" defaultMessage="Hand-drawn patterns of colour layers crafted with science to accentuate and not mask the natural beauty and hues of your eyes." /></p>
                </div>
              </div>
            </li>
            <li className="feature-item">
              <div className="feature-item-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
                  <path d="M35,1L35,1c18.8,0,34,15.2,34,34l0,0c0,18.8-15.2,34-34,34l0,0C16.2,69,1,53.8,1,35l0,0C1,16.2,16.2,1,35,1z" />
                  <path
                    d="M40.6,39c0,0.3,0.1,0.5,0.1,0.8c0,3.3-2.7,6-6.1,6c-3.4,0-6.1-2.7-6.1-6c0-3.3,2.7-6,6.1-6c0.4,0,0.8,0,1.2,0.1
                  "
                  />
                  <path d="M38.9,39c1.9,0,3.5-1.5,3.5-3.5s-1.6-3.5-3.5-3.5s-3.5,1.5-3.5,3.5S37,39,38.9,39z" />
                  <path d="M34.6,42.3c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5C32,41.2,33.2,42.3,34.6,42.3z" />
                  <path d="M34.6,49.6c5.5,0,10-4.4,10-9.8c0-5.4-4.5-9.8-10-9.8s-10,4.4-10,9.8C24.6,45.2,29.1,49.6,34.6,49.6z" />
                  <path d="M56.8,39.8c-23.6-28.8-44.7,0-44.7,0S33.1,68.7,56.8,39.8z" />
                  <path
                    d="M44.3,17.6l-1.3,2c0,0,0,0-0.1,0.1l-1.9,1.2c-0.1,0.1-0.1,0.3,0,0.3l1.9,1.1c0,0,0,0,0.1,0.1l1.3,2
                  c0.1,0.1,0.3,0.1,0.3,0l1.3-1.9c0,0,0,0,0.1-0.1l1.9-1.2c0.1-0.1,0.1-0.3,0-0.3L46,19.7c0,0,0,0-0.1-0.1l-1.3-2
                  C44.6,17.5,44.4,17.5,44.3,17.6L44.3,17.6z"
                  />
                  <path
                    d="M52.2,21.8l-1.6,2.5c0,0,0,0.1-0.1,0.1l-2.4,1.5c-0.2,0.1-0.2,0.3,0,0.4l2.3,1.4c0,0,0.1,0,0.1,0.1l1.6,2.6
                  c0.1,0.2,0.3,0.2,0.4,0l1.6-2.5c0,0,0-0.1,0.1-0.1l2.4-1.6c0.2-0.1,0.2-0.3,0-0.4l-2.4-1.5c0,0-0.1,0-0.1-0.1l-1.6-2.5
                  C52.6,21.7,52.3,21.7,52.2,21.8L52.2,21.8z"
                  />
                </svg>
                <div className="separator"></div>
                <div className="details">
                  <h6><FormattedHTMLMessage id="features.paragraph2.title" defaultMessage="Breathability <span>^</span>" /></h6>
                  <p><FormattedHTMLMessage id="features.paragraph2.description" defaultMessage="Our etafilcon A hydrogel material delivers 88% of available oxygen to the eye for long-lasting moisture and comfort." /></p>
                </div>
              </div>
            </li>
            <li className="feature-item">
              <div className="feature-item-wrapper">
                <svg viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path d="m35 1c18.8 0 34 15.2 34 34 0 18.8-15.2 34-34 34-18.8 0-34-15.2-34-34 0-18.8 15.2-34 34-34z" />
                    <path
                      clipPath="url(#a)"
                      d="m34.5 55.1c10.3 0 18.6-1.7 18.6-3.8s-8.3-3.8-18.6-3.8-18.6 1.7-18.6 3.8 8.4 3.8 18.6 3.8z"
                    />
                    <path
                      clipPath="url(#a)"
                      d="m15.9 51.4c0-9.5 8.3-17.3 18.6-17.3s18.6 7.7 18.6 17.3"
                    />
                    <path clipPath="url(#a)" d="m36.1 27.4-1.5 3.2-3.1-4.2" />
                    <path
                      clipPath="url(#a)"
                      d="m28.9 22.8 2.1 1 2.1 1-1.9 1.3-1.9 1.3-.2-2.3z"
                    />
                    <g>
                      <path
                        clipPath="url(#a)"
                        d="m47.9 22.8c1.5 0 2.7-1.2 2.7-2.7s-1.2-2.7-2.7-2.7-2.7 1.2-2.7 2.7 1.2 2.7 2.7 2.7z"
                      />
                      <path clipPath="url(#a)" d="m48 14.7v-1.9" />
                      <path clipPath="url(#a)" d="m48 27.3v-1.9" />
                      <path clipPath="url(#a)" d="m53.3 20.1h1.8" />
                      <path clipPath="url(#a)" d="m40.8 20.1h1.8" />
                      <path clipPath="url(#a)" d="m44.2 16.3-1.3-1.3" />
                      <path clipPath="url(#a)" d="m53 25.2-1.3-1.3" />
                      <path clipPath="url(#a)" d="m51.7 16.3 1.3-1.3" />
                      <path clipPath="url(#a)" d="m42.9 25.2 1.3-1.3" />
                    </g>
                  </g>
                </svg>
                <div className="separator"></div>
                <div className="details">
                  <h6><FormattedHTMLMessage id="features.paragraph3.title" defaultMessage="Class 2 UV blocking <span>##</span>" /></h6>
                  {defineType == 'fresh' && (
                    <p><FormattedHTMLMessage id="features.paragraph3.freshdescription" defaultMessage="Blocks ~82% of UVA and ~97% of UVB rays so you can enjoy protection in the sun." /></p>
                  )}
                  {defineType == 'classic' && (
                    <p><FormattedHTMLMessage id="features.paragraph3.classicdescription" defaultMessage="Blocks ~81% of UVA and ~97% of UVB rays so you can enjoy protection in the sun." /></p>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </section>
        {/* Specs */}
        <section className="specs-wrapper">
          <div className="specs-content">
            <input type="checkbox" id="specs-toggle" />
            <label htmlFor="specs-toggle" tabIndex="0" className="specs-bar">
              <h6>
                <em><FormattedMessage id="specs.specifications" defaultMessage="Specifications" /></em>
              </h6>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M12.0711 13.3139L17.0211 8.36388C17.1134 8.26837 17.2237 8.19219 17.3457 8.13978C17.4677 8.08737 17.599 8.05979 17.7317 8.05863C17.8645 8.05748 17.9962 8.08278 18.1191 8.13306C18.242 8.18334 18.3536 8.25759 18.4475 8.35149C18.5414 8.44538 18.6157 8.55703 18.666 8.67993C18.7162 8.80282 18.7415 8.9345 18.7404 9.06728C18.7392 9.20006 18.7117 9.33128 18.6592 9.45329C18.6068 9.57529 18.5307 9.68564 18.4351 9.77788L12.7781 15.4349C12.5906 15.6224 12.3363 15.7277 12.0711 15.7277C11.806 15.7277 11.5517 15.6224 11.3641 15.4349L5.70714 9.77788C5.61163 9.68564 5.53545 9.57529 5.48304 9.45329C5.43063 9.33128 5.40305 9.20006 5.40189 9.06728C5.40074 8.9345 5.42604 8.80282 5.47632 8.67993C5.5266 8.55703 5.60086 8.44538 5.69475 8.35149C5.78864 8.25759 5.90029 8.18334 6.02319 8.13306C6.14609 8.08278 6.27777 8.05748 6.41054 8.05863C6.54332 8.05979 6.67454 8.08737 6.79655 8.13978C6.91855 8.19219 7.0289 8.26837 7.12114 8.36388L12.0711 13.3139Z" />
              </svg>
            </label>
            <div className="spec-list">
              <h6>
                <em><FormattedMessage id="specs.additionalInfo" defaultMessage="Additional Information" /></em>
              </h6>
              <ul className="spec-list-wrapper">
                <li className="spec-item">
                  <img src={icon_specs_power} className="icon" />
                  {defineType == 'fresh' && (
                    <p className="label"><FormattedMessage id="specs.freshpowerRange" defaultMessage="Power Range" /></p>
                  )}
                  {defineType == 'fresh' && (
                    <p className="details">
                      <FormattedHTMLMessage id="specs.freshpowerRange.detail" defaultMessage="+1.00D to Plano (0.50D steps);<br />-0.50D to -6.00D (0.25D steps);<br />-6.50D to -9.00D (0.50D steps)" />
                    </p>
                  )}
                  {defineType == 'classic' && (
                    <p className="label"><FormattedMessage id="specs.classicpowerRange" defaultMessage="Power Range" /></p>
                  )}
                  {defineType == 'classic' && (
                    <p className="details">
                      <FormattedHTMLMessage id="specs.classicpowerRange.detail" defaultMessage="+1.00D to Plano (0.50D steps);<br />-0.50D to -6.00D (0.25D steps);<br />-6.50D to -9.00D (0.50D steps)" />
                    </p>
                  )}
                </li>
                <li className="spec-item">
                  <img src={icon_specs_curve} className="icon" />
                  <p className="label"><FormattedMessage id="specs.baseCurve" defaultMessage="Base Curve" /></p>
                  <p className="details"><FormattedMessage id="specs.baseCurve.detail" defaultMessage="8.5mm" /></p>
                </li>
                <li className="spec-item diameter">
                  <img src={icon_specs_thickness} className="icon" />
                  <p className="label"><FormattedMessage id="specs.centre" defaultMessage="Centre Thickness" /></p>
                  <p className="details"><FormattedMessage id={"specs.centre."+defineType+".detail"} defaultMessage="14.2mm" /></p>
                </li>
                <li className="spec-item">
                  <img src={icon_specs_material} className="icon" />
                  <p className="label"><FormattedMessage id="specs.material" defaultMessage="Material" /></p>
                  <p className="details"><FormattedMessage id="specs.material.detail" defaultMessage="Etafilcon A" /></p>
                </li>
                <li className="spec-item">
                  <img src={icon_specs_wetting} className="icon" />
                  <p className="label"><FormattedMessage id="specs.internal" defaultMessage="Internal Wetting Agent" /></p>
                  <p className="details"><FormattedMessage id="specs.internal.detail" defaultMessage="Polyvinylpyrrolidone (PVP) using LACREON® Technology" /></p>
                </li>
                <li className="spec-item">
                  <img src={icon_specs_water} className="icon" />
                  <p className="label"><FormattedMessage id="specs.water" defaultMessage="Water Content" /></p>
                  <p className="details"><FormattedMessage id="specs.water.detail" defaultMessage="58%" /></p>
                </li>
                <li className="spec-item oxygen">
                  <img src={icon_specs_o2} className="icon" />
                  <p className="label"><FormattedMessage id="specs.oxygen" defaultMessage="Oxygen Transmissibility" /></p>
                  <p className="details"><FormattedHTMLMessage id="specs.oxygen.detail" defaultMessage="(Dk/t) (boundary & edge corrected) 25.5 x 10-9 (for -3.00D)" /></p>
                </li>
                <li className="spec-item">
                  <img src={icon_specs_package} className="icon" />
                  <p className="label"><FormattedMessage id="specs.packageSize" defaultMessage="Package Size" /></p>
                  <p className="details"><FormattedHTMLMessage id={"specs.packageSize."+defineType+".detail"} defaultMessage="30 lenses/box" /></p>
                </li>
              </ul>
            </div>
            <div className="illustration">
              <img src={img_specs_classic} />
              <h3>
                <em><FormattedMessage id="specs.specifications" defaultMessage="Specifications" /></em>
              </h3>
            </div>
            <div className="decoration">
              <img src={sprite_ring_text_specs} />
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 8">
                <path d="M7.96363 1.44256L7.85791 1.64349C7.0843 3.11929 7.0843 4.88073 7.85791 6.35653L7.96363 6.55746C8.41029 7.41018 7.49106 8.3301 6.63834 7.88274C5.03652 7.04333 3.12526 7.04333 1.52344 7.88274C0.670723 8.3294 -0.249204 7.41018 0.198158 6.55746L0.303872 6.35653C1.07748 4.88073 1.07748 3.11929 0.303872 1.64349L0.198158 1.44256C-0.249204 0.589841 0.670023 -0.329385 1.52274 0.117276C3.12456 0.956692 5.03582 0.956692 6.63764 0.117276C7.49036 -0.329385 8.41029 0.589841 7.96292 1.44256H7.96363Z" />
              </svg>
            </div>
          </div>
        </section>
        {/* Lens Wear */}
        <section className="lens-wear-wrapper">
          <div className="heading">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
              <path d="M11.8248 2.16311L11.6663 2.4645C10.5059 4.6782 10.5059 7.32036 11.6663 9.53407L11.8248 9.83546C12.4948 11.1145 11.116 12.4944 9.83691 11.8234C7.43418 10.5643 4.56729 10.5643 2.16455 11.8234C0.885479 12.4934 -0.494411 11.1145 0.176631 9.83546L0.335203 9.53407C1.49561 7.32036 1.49561 4.6782 0.335203 2.4645L0.176631 2.16311C-0.494411 0.884029 0.884428 -0.49481 2.1635 0.175182C4.56623 1.4343 7.43313 1.4343 9.83586 0.175182C11.1149 -0.49481 12.4948 0.884029 11.8238 2.16311H11.8248Z" />
            </svg>
            <h3>
              <em><FormattedMessage id="lensWear.title" defaultMessage="Lens Wear" /></em>
            </h3>
            <p><FormattedMessage id="lensWear.howToPut" defaultMessage="How to put in and remove your contact lenses." /></p>
            <img
              src={img_wear_classic}
              alt="A hand holding up a box of Acuvue Define® classic"
            />
          </div>
          <div className="tab-controls">
            <div
              className="indicator"
              style={{ translate: tabControls == 'insertion' ? '0%' : '100%' }}
            ></div>
            <div
              data-steps="insertion"
              onClick={() => setTabControls('insertion')}
              className={tabControls == 'insertion' ? 'tab active' : 'tab'}
            >
              <em><FormattedMessage id="lensWear.insertion" defaultMessage="Insertion" /></em>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16">
                <path d="M12.3 10.6c-.1.1-.2.3-.2.4s.1.3.2.4c.1.1.3.2.4.2.2 0 .3-.1.4-.2l2.9-3c.2-.2.2-.6 0-.8l-3-2.9c-.2-.3-.6-.3-.7 0-.2.1-.2.2-.2.4s.1.3.2.4l2 2H6.8c-.3 0-.6.2-.6.5s.3.6.6.6h7.4l-1.9 2z" />
                <path d="M13.7 1.6c-1.9 0-3.7.8-4.9 2.3-.3.2-.2.6 0 .8.3.2.6.2.8-.1 1-1.2 2.4-1.9 4-1.9 2.9 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2c-1.5 0-3-.7-4-1.9-.2-.3-.6-.3-.8-.1-.3.2-.3.6-.1.8 1.2 1.5 3 2.3 4.9 2.3 3.5 0 6.4-2.9 6.4-6.4s-2.8-6.2-6.3-6.2z" />
              </svg>
            </div>
            <div
              data-steps="removal"
              onClick={() => setTabControls('removal')}
              className={tabControls == 'removal' ? 'tab active' : 'tab'}
            >
              <em><FormattedMessage id="lensWear.removal" defaultMessage="Removal" /></em>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16">
                <path d="M5.1 8.5h7.3c.3 0 .6-.3.6-.5 0-.3-.3-.5-.5-.5H5.1l2-2c.2-.2.2-.5 0-.8-.2-.2-.5-.2-.8 0l-2.9 3c-.2.2-.2.5 0 .8l2.9 2.9c.1.1.3.2.4.2s.3-.1.4-.2c.2-.2.2-.5 0-.8l-2-2.1z" />
                <path d="M13.7 1.6c-1.9 0-3.7.8-4.9 2.3-.2.2-.2.6 0 .8.3.2.6.2.8-.1 1-1.2 2.4-1.9 4-1.9 2.9 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2c-1.5 0-3-.7-4-1.9-.2-.3-.6-.3-.8-.1s-.3.6-.1.8c1.2 1.4 3 2.3 4.9 2.3 3.5 0 6.4-2.9 6.4-6.4.1-3.3-2.8-6.2-6.3-6.2z" />
              </svg>
            </div>
          </div>
          <div className="instructions">
            <ol
              className="instructions-wrapper insertion"
              style={{ translate: tabControls == 'insertion' ? '0%' : '-100%' }}
            >
              <li className="step">
                <img src={img_wear_insert_01} />
                <div className="details">
                  <div className="number">01</div>
                  <h6><FormattedMessage id="lensWear.insert1.title" defaultMessage="Start off clean" /></h6>
                  <p><FormattedMessage id="lensWear.insert1.description" defaultMessage="Wash hands with non-perfumed, anti-bacterial soap, and dry off with a lint-free towel." /></p>
                </div>
              </li>
              <li className="step">
                <img src={img_wear_insert_02} />
                <div className="details">
                  <div className="number">02</div>
                  <h6><FormattedMessage id="lensWear.insert2.title" defaultMessage="Check lens orientation" /></h6>
                  <p><FormattedMessage id="lensWear.insert2.description" defaultMessage="Place lens on fingertip and hold it up to the light. If the edges flare out, it’s inside out—simply flip the lens." /></p>
                </div>
              </li>
              <li className="step">
                <img src={img_wear_insert_03} />
                <div className="details">
                  <div className="number">03</div>
                  <h6><FormattedMessage id="lensWear.insert3.title" defaultMessage="Lift lids for insertion" /></h6>
                  <p><FormattedMessage id="lensWear.insert3.description" defaultMessage="Gently lift your upper and lower eyelid with one finger each to prevent blinking or eyelash obstruction." /></p>
                </div>
              </li>
              <li className="step">
                <img src={img_wear_insert_04} />
                <div className="details">
                  <div className="number">04</div>
                  <h6><FormattedMessage id="lensWear.insert4.title" defaultMessage="Close eyelid to settle" /></h6>
                  <p><FormattedMessage id="lensWear.insert4.description" defaultMessage="While looking upward, move the lens toward your eye steadily. Slowly release your eyelid and close your eye to allow the lens to settle." /></p>
                </div>
              </li>
            </ol>
            <ol
              className="instructions-wrapper removal"
              style={{ translate: tabControls == 'insertion' ? '0%' : '-100%' }}
            >
              <li className="step">
                <img src={img_wear_remove_01} />
                <div className="details">
                  <div className="number">01</div>
                  <h6><FormattedMessage id="lensWear.remove1.title" defaultMessage="Gently lower eyelid" /></h6>
                  <p><FormattedMessage id="lensWear.remove1.description" defaultMessage="Ensure hands are clean and dry, then look up and carefully pull down your lower eyelid with your middle finger" /></p>
                </div>
              </li>
              <li className="step">
                <img src={img_wear_remove_02} />
                <div className="details">
                  <div className="number">02</div>
                  <h6><FormattedMessage id="lensWear.remove2.title" defaultMessage="Slide and lower lens" /></h6>
                  <p><FormattedMessage id="lensWear.remove2.description" defaultMessage="Bring your index finger to your eye slowly until you touch the lower edge of the lens, then slide the lens down to the lower white part of your eye." /></p>
                </div>
              </li>
              <li className="step">
                <img src={img_wear_remove_03} />
                <div className="details">
                  <div className="number">03</div>
                  <h6><FormattedMessage id="lensWear.remove3.title" defaultMessage="Pinch to remove" /></h6>
                  <p><FormattedMessage id="lensWear.remove3.description" defaultMessage="Gently pinch the lens with your thumb and index finger and remove it." /></p>
                </div>
              </li>
              <li className="step">
                <img src={img_wear_remove_04} />
                <div className="details">
                  <div className="number">04</div>
                  <h6><FormattedMessage id="lensWear.remove4.title" defaultMessage="Discard" /></h6>
                  <p><FormattedMessage id="lensWear.remove4.description" defaultMessage="1-day ACUVUE® Define® contact lenses are daily disposable lenses, so discard them after removal." /></p>
                </div>
              </li>
            </ol>
          </div>
        </section>
        {/* Shop Now */}
        <div ref={sectionRef}></div>
        <ShowNow></ShowNow>
        {/* Related */}
        {defineType == 'classic' && (
          <section className="related-wrapper">
            <div className="illustration">
              <h3>
                <em><FormattedMessage id="related.discover" defaultMessage="Discover" /></em>
              </h3>
              <img
                src={img_package_fresh}
                alt="Acuvue Define® Fresh packaging"
              />
            </div>
            <h4><FormattedMessage id="headline.fresh.title" defaultMessage="Define® Fresh" /></h4>
            <p><FormattedHTMLMessage id="headline.fresh.description" defaultMessage="Scientifically designed to enhance, brighten and lighten with playful nature-inspired colours" /></p>
            <a onClick={() => redirectTo('/define-fresh')} className="btn tertiary">
              <FormattedMessage id="buttonText.discoverDefineFresh" defaultMessage="Discover Define® Fresh" />
              <div className="arrow btn-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 40 12"
                  fill="none"
                >
                  <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3" />
                </svg>
              </div>
            </a>
          </section>
        )}
        {defineType == 'fresh' && (
          <section className="related-wrapper">
            <div className="illustration">
              <h3>
                <em><FormattedMessage id="related.discover" defaultMessage="Discover" /></em>
              </h3>
              <img
                src={img_package_classic}
                alt="Acuvue Define® Classic packaging"
              />
            </div>
            <h4><FormattedMessage id="headline.classic.title" defaultMessage="Define® Classic" /></h4>
            <p><FormattedHTMLMessage id="headline.classic.description" defaultMessage="Innovatively crafted natural-toned hues featuring limbal rings that accentuate with bold&nbsp;charisma" /></p>
            <a onClick={() => redirectTo('/define-classic')} className="btn tertiary">
              <FormattedMessage id="buttonText.discoverDefineClassic" defaultMessage="Discover Define® Classic" />
              <div className="arrow btn-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 40 12"
                  fill="none"
                >
                  <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3" />
                </svg>
              </div>
            </a>
          </section>
        )}
      </main>
      {/* References */}
      <References></References>
      {/* Virtual Mirror Modal */}
      {showDefineModal ? (
      <div className="define-modal vm-modal">
        <ContextContainer>
          <div className="vm-content">
            <VirtualMirror {...props} selectedLens={selectedLens} />
            <div className="close-btn" onClick={() => setShowDefineModal(false)}><p>×</p></div>
          </div>
        </ContextContainer>
      </div>) : ""}
    </React.Fragment>
  );
};

export default injectIntl(Define);
